import React from "react"

import { cn } from "@/lib/utils"

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  // eslint-disable-next-line react/prop-types
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "border-input ring-offset-background placeholder:text-muted-foreground focus-visible:ring-ring bg-card flex min-h-[80px] w-full rounded-md border px-3 py-2 text-base focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          "placeholder:text-muted-foreground placeholder:text-[15px] placeholder:leading-[23px] placeholder:font-[400] placeholder:tracking-[0px] placeholder:opacity-[0.51]",
          className,
        )}
        ref={ref}
        {...props}
      />
    )
  },
)
Textarea.displayName = "Textarea"

export { Textarea }
